/* eslint-disable no-constant-condition */
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '&store/store';

import { ChallengeDetailsWrapper } from './challengeDetails.styled';
import Container from '../../components/container/container.component';
import ChallengeImg from '&assets/images/AWS-Empty-8.jpg';
import CollaborateComponent from '../../components/collaborate/collaborate.component';
import ThemesComponent from '../../components/themes/themes.component';
import EligibilityComponent from '../../components/eligibility/eligibility.component';
import EvaluationCriteriaComponent from '../../components/evaluationCriteria/evaluationCriteria.component';
import PrizesComponent from '../../components/prizes/prizes.component';
import { challengeDetailsActions } from './challengeDetails.slice';
import { useLocation, useNavigate } from 'react-router-dom';
import ChallengeTimelineComponent from '../../components/challengeTimeline/challengeTimeline.component';
import Navbar from '../../components/navbar/navbar.component';
import { CircularProgress } from '@mui/material';

type ReduxProps = ConnectedProps<typeof connector>;

const ChallengeDetailsComponent = (props: ReduxProps) => {
	const { getChallengeById, challenge, loading } = props;
	const { t } = useTranslation(['home']);
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const pk: any = location.pathname.split('/')[2];
		if (pk) {
			getChallengeById(pk);
		} else {
			navigate('/');
		}
	}, []);

	return (
		<ChallengeDetailsWrapper backgroundImage={ChallengeImg}>
			{loading ? (
				<div className="loading-center">
					<CircularProgress size={40} color="inherit" />
				</div>
			) : (
				<>
					<div className="challenge-header">
						<p className="challenge-name">{challenge?.title}</p>
					</div>
					<CollaborateComponent landing={false} />
					<ThemesComponent landing={false} challenge={challenge} />
					<ChallengeTimelineComponent timeLine={challenge.timeline} />
					<EligibilityComponent challenge={challenge} />
					<EvaluationCriteriaComponent
						criteria={challenge.evaluationCriteria}
					/>
					<PrizesComponent prizes={challenge.prizes} />
				</>
			)}
		</ChallengeDetailsWrapper>
	);
};

const mapStateToProps = (state: RootState) => ({
	challenge: state.challengeDetails.challenge,
	loading: state.challengeDetails.loading,
});

const mapDispatchToProps = {
	getChallengeById: challengeDetailsActions.getChallengeById,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ChallengeDetailsComponentRedux = connector(ChallengeDetailsComponent);

export { ChallengeDetailsComponentRedux as ChallengeDetailsComponent };
